import { getMessageCreationTime } from "../../Chat/helpers/getMessageCreationTime";

const getlastMessageTime = (timestamp) => {
  if(!timestamp) return '';
  return getMessageCreationTime(timestamp.toDate());
}

export default getlastMessageTime;
